var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1749105093637,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 17205,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.1 64v59.7C251.2 123.7 64 310.9 64 541.9 64 772.8 251.2 960 482.1 960c230.9 0 418.1-187.2 418.1-418.1H960C960 277.9 746.1 64 482.1 64z m59.8 64C724.7 154.3 869.7 299.3 896 482.1H541.9V128z m-59.8 772.3c-197.6 0-358.4-160.8-358.4-358.4s160.8-358.4 358.4-358.4v358.4h358.4c0 197.6-160.7 358.4-358.4 358.4z",
    fill: "currentColor",
    "p-id": 17206
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.84e6e200c5658f5e1a76723b66cd802b.svg";
export { ForwardRef as ReactComponent };